// extracted by mini-css-extract-plugin
module.exports = {"jds-Divider":"divider_jds-Divider__v_d_b","jds-Divider--white":"divider_jds-Divider--white__D_HWR"};